import EditProductsPane from '../../components/vehicles/edit-vehicle/EditProductsPane'
import { connect } from 'react-redux'
import { IStoreState, IUpdateVehicleProviderProducts } from '../../types'
import { fetchProductsByOrganizationId } from '../../state/actions/provider-products'
import { actionCreators, getSingleVehicle, updateVehicleProviderProducts } from '../../state/actions/vehicles'
import { RouteComponentProps } from 'react-router'

const mapStateToProps = (nextStep: string) => (state: IStoreState, ownProps: RouteComponentProps<{ id: string }>) => {
  return {
    organizationId: state.organizations.currentOrgId || '',
    createEditVehicleRequest: state.vehicles.createEditVehicleLoading,
    createEditVehicle: state.vehicles.createEditVehicle,
    createEditVehicleError: state.vehicles.createEditVehicleFail,
    products: Object.values(state.providerProduct.items),
    allProducts: Object.values(state.providerProduct.items),
    vehicle: state.vehicles.items[ownProps.match.params.id],
    isSaved: state.vehicles.isSaved,
    isRequesting: state.vehicles.isLoading,
    nextStep,
    ...ownProps
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateVehicleProviderProducts: (data: IUpdateVehicleProviderProducts) =>
      dispatch(updateVehicleProviderProducts(data)),
    getVehicleById: (id: string) => dispatch(getSingleVehicle(id)),
    setVehicleSavedStateToInitial: () => dispatch(actionCreators.setVehicleSavedStateToInitial()),
    fetchProductsByOrganizationId: (organizationId: string) => {
      const dto = {
        organizationId,
        skip: 0,
        take: 9999, // get all existing products
        active: true
      }
      dispatch(fetchProductsByOrganizationId(dto))
    }
  }
}

export default (nextStep: string) =>
  connect(
    mapStateToProps(nextStep),
    mapDispatchToProps
  )(EditProductsPane)



// WEBPACK FOOTER //
// ./src/containers/vehicles/EditProductsPane.ts